import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { union } from "ramda";

import { ALGOLIA_FILTERS } from "enums";

const initialState = {
  castNumFilters: [],
  templateGroupTypeFilters: [],
  isClearAllClicked: false,
  itemToRemove: null,
  sortFilterSelected: {},
  numberOfPeopleFilters: {},
  contentTypesFilters: {},
};

const algoliaSlice = createSlice({
  name: "algolia",
  initialState,
  reducers: {
    addOneFilter(state, { payload }) {
      payload.filterType === ALGOLIA_FILTERS.castNumOptions
        ? (state.castNumFilters = union(state.castNumFilters, [payload.item])
            .sort()
            .reverse())
        : (state.templateGroupTypeFilters = union(state.templateGroupTypeFilters, [payload.item]).sort());
    },
    removeOneFilter(state, { payload }) {
      payload.filterType === ALGOLIA_FILTERS.castNumOptions
        ? (state.castNumFilters = state.castNumFilters.filter((item) => item !== payload.item))
        : (state.templateGroupTypeFilters = state.templateGroupTypeFilters.filter((item) => item !== payload.item));
    },
    clearFilter(state, { payload }) {
      payload === ALGOLIA_FILTERS.castNumOptions ? (state.castNumFilters = []) : (state.templateGroupTypeFilters = []);
    },
    clearAllFilters(state) {
      state.castNumFilters = [];
      state.numberOfPeopleFilters = {};
      state.templateGroupTypeFilters = [];
      state.contentTypesFilters = {};
      state.sortFilterSelected = {};
    },
    clearAllFiltersByPath(state, { payload }) {
      if (!payload?.path) return;

      delete state.sortFilterSelected[payload.path];
      delete state.numberOfPeopleFilters[payload.path];
      delete state.contentTypesFilters[payload.path];
    },
    setIsClearAllClicked(state, { payload }) {
      state.isClearAllClicked = payload;
    },
    setItemToRemove(state, { payload }) {
      state.itemToRemove = payload;
    },
    setSortFilterSelected(state, { payload }) {
      if (!payload?.path) return;

      state.sortFilterSelected = {
        ...state.sortFilterSelected,
        [payload.path]: payload.filterValue,
      };
    },
    setNumberOfPeopleFilters(state, { payload }) {
      if (!payload?.path) return;

      state.numberOfPeopleFilters = {
        ...state.numberOfPeopleFilters,
        [payload.path]: payload.filterValue,
      };
    },
    setContentTypesFilters(state, { payload }) {
      if (!payload?.path) return;

      state.contentTypesFilters = {
        ...state.contentTypesFilters,
        [payload.path]: payload.filterValue,
      };
    },
  },
});

export const { actions } = algoliaSlice;
export default algoliaSlice.reducer;

export const useAlgoliaActions = () => {
  const dispatch = useDispatch();

  const addOneFilter = (params) => {
    dispatch(algoliaSlice.actions.addOneFilter(params));
  };

  const removeOneFilter = (params) => {
    dispatch(algoliaSlice.actions.removeOneFilter(params));
  };

  const clearFilter = (params) => {
    dispatch(algoliaSlice.actions.clearFilter(params));
  };

  const clearAllFilters = () => {
    dispatch(algoliaSlice.actions.clearAllFilters());
  };

  const setIsClearAllClicked = (params) => {
    dispatch(algoliaSlice.actions.setIsClearAllClicked(params));
  };

  const clearAllFiltersByPath = (params) => {
    dispatch(algoliaSlice.actions.clearAllFiltersByPath(params));
  };

  const setItemToRemove = (params) => {
    dispatch(algoliaSlice.actions.setItemToRemove(params));
  };

  const setSortFilterSelected = (sortLabel) => {
    dispatch(algoliaSlice.actions.setSortFilterSelected(sortLabel));
  };

  const setNumberOfPeopleFilters = (params) => {
    dispatch(algoliaSlice.actions.setNumberOfPeopleFilters(params));
  };

  const setContentTypesFilters = (params) => {
    dispatch(algoliaSlice.actions.setContentTypesFilters(params));
  };

  return {
    addOneFilter,
    removeOneFilter,
    clearFilter,
    clearAllFilters,
    clearAllFiltersByPath,
    setIsClearAllClicked,
    setItemToRemove,
    setSortFilterSelected,
    setNumberOfPeopleFilters,
    setContentTypesFilters,
  };
};
